export const API_BASE = '/api'